import React from "react";

const initials = (src) =>
  (src || "BB")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

const NewsFeed = ({ news = [] }) => {
  return (
    <div className="panel entrance" data-testid="news-panel">
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic"><i className="fa-regular fa-newspaper" /></div>
          Newswire · Last 24h
        </div>
        <span className="pill neutral">Barbados</span>
      </div>

      <div className="feed" data-testid="news-feed" style={{ gap: 4 }}>
        {news.map((n) => (
          <a
            key={n.id}
            className="news-item"
            href={n.link || "#"}
            target="_blank"
            rel="noreferrer"
            data-testid={`news-${n.id}`}
            style={{ textDecoration: "none" }}
          >
            <div className="news-thumb">{initials(n.source)}</div>
            <div>
              <div className="news-t">{n.title}</div>
              <div className="news-s">
                {n.source} · {n.category} · {n.minutes_ago} min ago
                {n.affects_traffic && <span className="chip" style={{ marginLeft: 8 }}>traffic</span>}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default NewsFeed;
